import { Tabs } from '@app/components'
import { TabsProps } from '@app/types'

import { Unlock } from './collections'

export const Discount = ({ isForDrawer = false }) => {
  const items: TabsProps['items'] = [
    // {
    //   children: <Lock isForDrawer={isForDrawer} />,
    //   key: '1',
    //   label: 'Lock',
    // },
    {
      children: <Unlock isForDrawer={isForDrawer} />,
      key: '2',
      label: 'Unlock',
    },
  ]

  return <Tabs centered defaultActiveKey="1" items={items} />
}
